<template>
    <restaurant-details-section
        class="restaurant-details-section-module"
        :lat="restaurantData.location_lat"
        :lng="restaurantData.location_lng"
        :address="restaurantData.address"
        :opening-hours-notice="restaurantData.opening_hours_notice"
        :opening-hours="openingHours"
        :telephone-number="restaurantData.telephone_number"
        :deliveroo-url="restaurantData.deliveroo_url"
        :uber-eats-url="restaurantData.uber_eats_url"
        :just-eat-url="restaurantData.just_eat_url"
        :facilities="facilities"
        :title="attributes.restaurantDetails_title"
        :view-menu-details="restaurantData.view_menu_details"
        :sale-text="restaurantData.sale_text"
    />
</template>

<script>
    import RestaurantDetailsSection from '../../../organisms/RestaurantDetailsSection/RestaurantDetailsSection';
    import dayjs from 'dayjs';
    import customParseFormat from 'dayjs/plugin/customParseFormat';

    dayjs.extend(customParseFormat);

    export default {
        name: 'restaurant-details-section-module',

        components: { RestaurantDetailsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Safely return the restaurant data.
             *
             * @returns {object}
             */
            restaurantData() {
                const { restaurant } = this.attributes;

                return restaurant?.data?.attributes || {};
            },

            /**
             * Normalise the opening hours data.
             *
             * @returns {object}
             */
            openingHours() {
                const normalisedTimeFormat = 'HH:mm';

                return [
                    'monday',
                    'tuesday',
                    'wednesday',
                    'thursday',
                    'friday',
                    'saturday',
                    'sunday',
                ].reduce((openingHours, day) => {
                    const {
                        [`${ day }_open`]: open,
                        [`${ day }_close`]: close,
                    } = this.restaurantData;

                    return {
                        ...openingHours,
                        [day]: {
                            open: open
                                ? dayjs(open, 'HH:mm')
                                    .format(normalisedTimeFormat)
                                : null,
                            close: close
                                ? dayjs(close, 'HH:mm')
                                    .format(normalisedTimeFormat)
                                : null,
                        },
                    };
                }, {});
            },

            /**
             * Return the facility names.
             *
             * @returns {Array}
             */
            facilities() {
                if (!this.restaurantData.facilities?.data) {
                    return [];
                }

                return this.restaurantData.facilities.data
                    .map(({ attributes }) => attributes.name);
            },
        },
    };
</script>
